export enum PoliceFireCrewStatus {
	Contacted = 'Contacted',
	Standby = 'Standing by',
}
